import { styled } from '@material-ui/core/styles';

export const StyledIconContainer = styled('div')(() => ({
  textAlign: 'center',
}));
